(function() {
  "use strict";

  angular.module("app").directive("cccAssetMapTable", cccAssetMapTable);

  function cccAssetMapTable() {
    return {
      restrict: "EA",
      scope: false,
      controller: "AssetMapTableController"
    };
  }
})();
